import { ErrorOutline } from '@material-ui/icons';

import { useTLang } from 'intl/intl';
import makeClasses from './BillingSection.style';

import type { UserInOrderDetail } from 'shared/domain';

export function BillingSection(props: Props) {
  const { user } = props;

  const lang = {
    alert: useTLang({ id: 'order.detail.clientModule.billing.alert' }),
    doc: {
      name: useTLang({ id: 'order.detail.clientModule.billing.doc.name' }),
      type: useTLang({ id: 'order.detail.clientModule.billing.doc.type' }),
      number: useTLang({ id: 'order.detail.clientModule.billing.doc.number' }),
    },
    bill: {
      type: useTLang({ id: 'order.detail.clientModule.billing.bill.type' }),
      email: useTLang({ id: 'order.detail.clientModule.billing.bill.email' }),
      address: useTLang({
        id: 'order.detail.clientModule.billing.bill.address',
      }),
      phone: useTLang({ id: 'order.detail.clientModule.billing.bill.phone' }),
    },
  };

  const _classes = makeClasses();

  return (
    <section aria-label='billing-section'>
      <div className={_classes.alert}>
        <ErrorOutline />
        <p>{lang.alert}</p>
      </div>
      <div aria-label='billing-info' className={_classes.info}>
        <dl>
          {!!user.billing.document.owner.value && (
            <div>
              <dt>{lang.doc.name}</dt>
              <dd>{user.billing.document.owner.value}</dd>
            </div>
          )}
          {user.billing.document.description.label && (
            <div>
              <dt>{lang.doc.type}</dt>
              <dd>{user.billing.document.description.label}</dd>
            </div>
          )}
          {!!user.billing.document.description.value && (
            <div>
              <dt>{lang.doc.number}</dt>
              <dd>{user.billing.document.description.value}</dd>
            </div>
          )}
          {!!user.billing.type && (
            <div>
              <dt>{lang.bill.type}</dt>
              <dd>{user.billing.type}</dd>
            </div>
          )}
          {!!user.billing.email && (
            <div>
              <dt>{lang.bill.phone}</dt>
              <dd>{user.billing.email}</dd>
            </div>
          )}
          {!!user.billing.address && (
            <div>
              <dt>{lang.bill.address}</dt>
              <dd>{user.billing.address}</dd>
            </div>
          )}
          {!!user.billing.phone && (
            <div>
              <dt>{lang.bill.phone}</dt>
              <dd>{user.phone.number}</dd>
            </div>
          )}
        </dl>
      </div>
    </section>
  );
}

interface Props {
  user: UserInOrderDetail;
}
